
export default {

};



// WEBPACK FOOTER //
// ./src/store/modules/box/getters.js